import React, { useState, useEffect, useContext } from 'react';
import { Card, Table, Button, Modal, InputNumber, message, Input } from 'antd';
import { LoginContext } from '../../context/loginContext';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CSalidaCliente = () => {
  const [articulosCliente, setArticulosCliente] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentArticulo, setCurrentArticulo] = useState(null);
  const [cantidadRetirar, setCantidadRetirar] = useState(0);
  const { user } = useContext(LoginContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchArticulosCliente();
  }, []);

  const fetchArticulosCliente = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/movimientos/articulos/por-cliente/${user.user.id}`,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      const articulosFormateados = response.data.map(articulo => ({
        ...articulo,
        nombreArticulo: articulo.articulo.nombre,
        marca: articulo.articulo.idmarca.nombre,
        categoria: articulo.articulo.idcategoria.nombre,
        unidadDeMedida: articulo.articulo.unidadDeMedida,
        cantidadDisponible: articulo.cantidad,
      }));

      setArticulosCliente(articulosFormateados);
    } catch (error) {
      message.error('Error al cargar artículos del cliente');
    }
  };

  const handleModalOk = () => {
    if (cantidadRetirar <= 0) {
      message.error('La cantidad debe ser mayor a 0');
      return;
    }

    if (cantidadRetirar > currentArticulo.cantidadDisponible) {
      message.error('La cantidad no puede superar el disponible');
      return;
    }

    const updatedArticulo = {
      ...currentArticulo,
      cantidadRetirar,
    };

    setSelectedItems((prev) => {

      // Si no existe, lo agrega
      return [...prev, updatedArticulo];
    });

    setModalVisible(false);
    setCantidadRetirar(0);
  };

// Dentro de tu componente...
const handleFinish = () => {
  Modal.confirm({
    title: '¿Desea finalizar y registrar este pedido?',
    content: 'Una vez registrado, no podrá modificarlo.',
    okText: 'Sí, finalizar',
    cancelText: 'Cancelar',
    onOk: async () => {
      const movimientos = selectedItems.map(item => ({
        articulo: item.articulo._id,
        cantidad: item.cantidadRetirar,
      }));

      const payload = {
        estado: "Pendiente",
        idCliente: user.user.id,
        items: movimientos,
      };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/pedido`,
          payload,
          { headers: { Authorization: `Bearer ${user.token}` } }
        );
        message.success("Movimiento registrado con éxito");
        setSelectedItems([]); // Limpia los artículos seleccionados después de confirmar
        fetchArticulosCliente(); // Actualiza la lista de artículos disponibles
        navigate('/pedidos-cliente');
      } catch (error) {
        console.error(error);
        message.error("Error al registrar el movimiento");
      }
    },
    onCancel() {
      message.info('Registro cancelado');
    },
  });
};

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <div>
          <Button
            type="primary"
            onClick={() => confirm()}
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            Buscar
          </Button>
          <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </div>
      </div>
    ),
    filterIcon: filtered => <span style={{ color: filtered ? '#1890ff' : undefined }}>🔍</span>,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
  });

  const columns = [
    {
      title: 'Artículo',
      dataIndex: 'nombreArticulo',
      ...getColumnSearchProps('nombreArticulo'),
    },
    {
      title: 'Marca',
      dataIndex: 'marca',
      ...getColumnSearchProps('marca'),
    },
    {
      title: 'Categoría',
      dataIndex: 'categoria',
      ...getColumnSearchProps('categoria'),
    },
    {
      title: 'Unidad de Medida',
      dataIndex: 'unidadDeMedida',
      ...getColumnSearchProps('unidadDeMedida'),
    },
    {
      title: 'Cantidad Disponible',
      dataIndex: 'cantidadDisponible',
    },
    {
      title: 'Acciones',
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => {
            setCurrentArticulo(record);
            setModalVisible(true);
          }}
        >
          Seleccionar
        </Button>
      ),
    },
  ];

  const selectedColumns = [
    {
      title: 'Artículo',
      dataIndex: 'nombreArticulo',
    },
    {
      title: 'Cantidad a Retirar',
      dataIndex: 'cantidadRetirar',
    },
    {
      title: 'Acciones',
      render: (_, record) => (
        <Button
          type="primary"
          danger
          onClick={() => {
            setSelectedItems(prev =>
              prev.filter(item => item._id !== record._id)
            );
          }}
        >
          Eliminar
        </Button>
      ),
    },
  ];

  return (
    <Card>
      <h2>Artículos Disponibles</h2>
      <Table
        dataSource={articulosCliente}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
        scroll={{ x: 800 }}
      />

      <h2 style={{ marginTop: 20 }}>Artículos Seleccionados</h2>
      <Table
        dataSource={selectedItems}
        columns={selectedColumns}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
        scroll={{ x: 800 }}
      />

      <Button
        type="primary"
        onClick={handleFinish}
        style={{ marginTop: 20 }}
        disabled={selectedItems.length === 0}
      >
        Finalizar
      </Button>

      <Modal
        title={`Seleccionar cantidad: ${currentArticulo?.nombreArticulo || ''}`}
        visible={modalVisible}
        onOk={handleModalOk}
        onCancel={() => {
          setModalVisible(false);
          setCantidadRetirar(0);
        }}
      >
        <div>
          <p>Cantidad disponible: {currentArticulo?.cantidadDisponible}</p>
          <InputNumber
            min={1}
            max={currentArticulo?.cantidadDisponible}
            value={cantidadRetirar}
            onChange={setCantidadRetirar}
            style={{ width: '100%' }}
          />
        </div>
      </Modal>
    </Card>
  );
};

export default CSalidaCliente;